import { useDispatch, useSelector } from 'react-redux';

import {
  legendOptions,
} from '../SourcesLegend/source-legend.constants';
import { setSelectedMode } from '../SourcesLegend/source-legend.store';
import './flowing-water-legend.css';

const energyFormatter = new Intl.NumberFormat('nl-BE', {
  maximumFractionDigits: 2,
});

function getLegendValues(maximum) {
  return [
    maximum,
    maximum * 0.8,
    maximum * 0.6,
    maximum * 0.4,
    maximum * 0.2,
    0,
  ].map(value => value.toFixed(2));
}

function formatLegendValue(value) {
  return energyFormatter.format(Number(value));
}

function FlowingWaterLegend({ maximums, onModeChange }) {
  const dispatch = useDispatch();
  const selectedMode = useSelector(state => state.sourceLegend.selectedMode);
  const maximum = maximums?.[selectedMode] || 0;
  const values = getLegendValues(maximum);
  const unit = selectedMode === 'temperature' ? '°C' : 'GWh/jaar';
  const label = `${legendOptions.find(option => option.value === selectedMode).label} (${unit})`;

  return (
    <div className="flowing-water-legend">
      <div className="flowing-water-legend__switch" role="group" aria-label="Legendaweergave">
        {legendOptions.map(({ label: optionLabel, value }) => (
          <button
            className={`flowing-water-legend__switch-option${selectedMode === value ? ' flowing-water-legend__switch-option--selected' : ''}`}
            key={value}
            type="button"
            aria-pressed={selectedMode === value}
            onClick={() => {
              dispatch(setSelectedMode(value));
              onModeChange?.(value);
            }}
          >
            {optionLabel}
          </button>
        ))}
      </div>
      <div className="flowing-water-legend__scale" role="img" aria-label={label}>
        <span className="flowing-water-legend__unit">{unit}</span>
        <span className="flowing-water-legend__width-sizer" aria-hidden="true">
          <span>{formatLegendValue(values[0])}</span>
          <i className="flowing-water-legend__tick" />
        </span>
        <div className="flowing-water-legend__gradient" aria-hidden="true" />
        <div className="flowing-water-legend__labels">
          {values.map(value => (
            <div className="flowing-water-legend__label" key={value}>
              <span>{formatLegendValue(value)}</span>
              <i className="flowing-water-legend__tick" aria-hidden="true" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default FlowingWaterLegend;
